import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const LeadSendDetail = (props) => {
  const [loading, setLoading] = useState(true);
  const [array, setArray] = useState([]);

  const fileReader = new FileReader();

  const fetchDetails = async () => {
    var body = {
      id: props.id,
    };

    await fetch("https://apisellcrm.ftpeople.pl/getLeadsSendSendId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setArray(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchDetails();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                Raport wysyłki kontaktu
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ textAlign: "left" }}>
              {array.map((el) => (
                <p
                  style={{
                    fontWeight: "300",
                    margin: "0",
                    marginBottom: "5px",
                  }}
                >
                  {el.companyName} - wysłano: {el.date}
                </p>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LeadSendDetail;
